export const translations = {
  fr: {
    // Auth
    welcomeBack: 'Bienvenue',
    login: 'Connexion',
    loginSubtitle: 'Connectez-vous pour trouver des fournisseurs fiables',
    email: 'Email',
    password: 'Mot de passe',
    loggingIn: 'Connexion...',
    dontHaveAccount: "Vous n'avez pas de compte ?",
    signUp: 'S\'inscrire',
    createAccount: 'Créer un compte',
    createAccountSubtitle: 'Commencez à trouver des fournisseurs fiables dès aujourd\'hui',
    fullName: 'Nom complet',
    creatingAccount: 'Création du compte...',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    register: 'Inscription',
    passwordStrength: 'Force du mot de passe',
    weak: 'Faible',
    medium: 'Moyen',
    strong: 'Fort',
    nameRequired: 'Le nom est requis',
    emailRequired: 'L\'email est requis',
    invalidEmail: 'Email invalide',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
    emailAlreadyUsed: 'Cet email est déjà utilisé',
    
    // Header
    logout: 'Déconnexion',
    
    // Dashboard
    dashboard: 'Tableau de bord',
    manageSearches: 'Gérez vos recherches de fournisseurs',
    newSearch: 'Nouvelle recherche',
    noSearchesYet: 'Aucune recherche',
    noSearchesDesc: 'Commencez par créer votre première recherche de fournisseurs',
    createNewSearch: 'Créer une recherche',
    quantity: 'Quantité',
    budget: 'Budget',
    suppliersFound: 'Fournisseurs trouvés',
    bestMatch: 'Meilleur choix',
    units: 'unités',
    
    // New Request
    newSupplierSearch: 'Nouvelle recherche de fournisseurs',
    tellUsWhatYouNeed: 'Dites-nous ce que vous recherchez',
    productName: 'Nom du produit',
    productNameRequired: 'Nom du produit *',
    productPlaceholder: 'ex: T-shirts en coton, Enceintes Bluetooth',
    quantityUnits: 'Quantité (unités)',
    quantityRequired: 'Quantité (unités) *',
    budgetUSD: 'Budget (USD)',
    budgetRequired: 'Budget (USD) *',
    additionalNotes: 'Notes supplémentaires (Optionnel)',
    notesPlaceholder: 'Certifications, préférences ou exigences spécifiques...',
    cancel: 'Annuler',
    findSuppliers: 'Trouver des fournisseurs',
    analyzingSuppliers: 'Analyse des fournisseurs...',
    failedToCreate: 'Échec de la création de la demande',
    
    // Results
    backToDashboard: 'Retour au tableau de bord',
    notes: 'Notes',
    bestMatchBadge: '\u2713 Meilleur choix',
    verified: 'Vérifié',
    pricePerUnit: 'Prix/Unité',
    moq: 'MOQ',
    leadTime: 'Délai',
    reliability: 'Fiabilité',
    days: 'jours',
    lowRisk: 'Risque faible',
    mediumRisk: 'Risque moyen',
    highRisk: 'Risque élevé',
    risk: 'Risque',
    generateMessage: 'Générer un message',
    failedToGenerate: 'Échec de la génération. Réessayez.',
    
    // Message Generator
    whatsappMessageFor: 'Message WhatsApp pour',
    generatingMessage: 'Génération du message professionnel...',
    copyToClipboard: 'Copier dans le presse-papier',
    copied: 'Copié !',
    messageLanguage: 'Langue du message',
    english: 'Anglais',
    french: 'Français',
    
    // Loading & Session
    analyzingSuppliersLoading: 'Analyse des fournisseurs et vérification des données...',
    requestNotFound: 'Demande non trouvée',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
    reconnect: 'Se reconnecter',
    
    // Refresh & History
    refreshSearch: 'Actualiser la recherche',
    refreshing: 'Actualisation...',
    lastUpdated: 'Dernière mise à jour',
    viewPreviousResults: 'Voir résultats précédents',
    viewCurrentResults: 'Voir résultats actuels',
    previousResults: 'Résultats précédents',
    currentResults: 'Résultats actuels',
    
    // Decision support
    priceRange: 'Fourchette de prix',
    estBestPrice: 'Meilleur prix estimé',
    topSupplier: 'Meilleur fournisseur',
    whyThisSupplier: 'Pourquoi ce fournisseur',
    scoreExplanation: 'Score basé sur le prix, le MOQ, le délai de livraison et la fiabilité du fournisseur',
    perUnit: '/unité',
    resultsSummary: 'Résumé de l\'analyse',
    // Score breakdown
    scoreBreakdown: 'Détail du score',
    overallScore: 'Score global',
    scorePrice: 'Prix',
    scoreMoq: 'MOQ',
    scoreDelivery: 'Livraison',
    scoreReliability: 'Fiabilité',
    weight: 'Poids',
    viewDetails: 'Voir le détail',
    hideDetails: 'Masquer le détail',
    scoreHelpTitle: 'Comment nous calculons ce score',
    scoreHelpIntro: 'Chaque fournisseur est noté sur 100 selon 4 critères pondérés :',
    scoreHelpPrice: 'Prix (40%) — compare le prix unitaire à votre budget par unité',
    scoreHelpMoq: 'MOQ (20%) — vérifie si la quantité minimum correspond à votre commande',
    scoreHelpDelivery: 'Livraison (20%) — plus le délai est court, meilleur est le score',
    scoreHelpReliability: 'Fiabilité (20%) — basée sur la vérification et l\'historique du fournisseur',
    // Decision support v2
    recommendedBecause: 'Pourquoi ce fournisseur :',
    scoreOutOf: 'Score',
    fastestSupplier: 'Livraison la plus rapide',
    lowestMoqInsight: 'MOQ le plus bas',
    bestPriceInsight: 'Meilleur prix',
    // Comparison
    addToComparison: 'Ajouter à la comparaison',
    removeFromComparison: 'Retirer de la comparaison',
    addedToComparison: 'Ajouté',
    compareSuppliersBtn: 'Comparer les fournisseurs',
    selectedForCompare: 'sélectionné(s) pour comparaison',
    maxComparisonReached: 'Maximum 3 fournisseurs',
    clearComparison: 'Effacer',
    comparisonTitle: 'Comparaison des fournisseurs',
    comparisonRowPrice: 'Prix par unité',
    comparisonRowMoq: 'MOQ',
    comparisonRowDelivery: 'Délai de livraison',
    comparisonRowReliability: 'Fiabilité',
    comparisonRowTotal: 'Score global',
    comparisonRowRisk: 'Niveau de risque',
    bestValue: 'Meilleur',
    worstValue: 'Le moins bon',
    winnerSummary: 'Notre recommandation',
    winnerExplain: 'est le meilleur choix car :',
    winsBestPrice: 'meilleur prix par unité',
    winsLowestMoq: 'MOQ le plus bas',
    winsFastestDelivery: 'livraison la plus rapide',
    winsHighestReliability: 'fiabilité la plus élevée',
    winsHighestScore: 'score global le plus élevé',
    winsLowestRisk: 'niveau de risque le plus faible',
    strengthsLabel: 'Points forts',
    weaknessesLabel: 'Points faibles',
    bestBadge: 'Top',
    worstBadge: 'Bas',
    // PDF export
    exportPdf: 'Exporter PDF',
    exportingPdf: 'Génération du PDF...',
    pdfReady: 'Rapport PDF téléchargé',
    pdfError: 'Échec de la génération du PDF',
    pdfEmptySaved: 'Aucun fournisseur à exporter',
    // Message generator v2
    messageType: 'Type de message',
    msgTypeWhatsapp: 'WhatsApp',
    msgTypeEmail: 'Email',
    messageTone: 'Ton',
    toneePolite: 'Poli',
    toneDirect: 'Direct',
    toneNegotiation: 'Négociation',
    toneePoliteHelp: 'Courtois et professionnel',
    toneDirectHelp: 'Court et droit au but',
    toneNegotiationHelp: 'Pousse pour un meilleur prix',
    regenerate: 'Régénérer',
    editMessage: 'Vous pouvez modifier le message avant de le copier',
    // Templates
    templatesNav: 'Modèles',
    templatesPageTitle: 'Modèles de messages',
    templatesPageSubtitle: 'Réutilisez vos meilleurs messages pour gagner du temps',
    newTemplate: 'Nouveau modèle',
    noTemplates: 'Aucun modèle pour le moment',
    noTemplatesDesc: 'Sauvegardez vos messages pour les réutiliser rapidement',
    templateName: 'Nom du modèle',
    templateNamePlaceholder: 'ex: Demande de prix rapide',
    templateCategory: 'Catégorie',
    templateBody: 'Contenu du message',
    templateBodyHelp: 'Utilisez {{supplier_name}}, {{product_name}}, {{quantity}}, {{budget}}, {{moq}}, {{lead_time}} comme variables.',
    save: 'Enregistrer',
    saveAsTemplate: 'Enregistrer comme modèle',
    useTemplate: 'Utiliser un modèle',
    edit: 'Modifier',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    confirmDelete: 'Supprimer ce modèle ?',
    templateSaved: 'Modèle enregistré',
    templateUpdated: 'Modèle mis à jour',
    templateDeleted: 'Modèle supprimé',
    templateDuplicated: 'Modèle dupliqué',
    templateApplied: 'Modèle appliqué',
    templateError: 'Une erreur est survenue',
    isDefault: 'Par défaut',
    customLabel: 'Personnalisé',
    usageCount: 'utilisations',
    pickATemplate: 'Choisir un modèle',
    suggestTemplate: 'Suggérer le meilleur modèle pour ce contexte',
    allCategories: 'Toutes les catégories',
    cat_price_inquiry: 'Demande de prix',
    cat_moq_negotiation: 'Négociation MOQ',
    cat_shipping_inquiry: 'Logistique',
    cat_sample_request: 'Échantillons',
    cat_branding: 'Personnalisation',
    cat_general_intro: 'Introduction',
    backToResults: 'Retour aux résultats',
    // Mobile navigation + workspace (FR)
    navHome: 'Accueil',
    navSaved: 'Enregistrés',
    navTracker: 'Pipeline',
    navTemplates: 'Modèles',
    navAccount: 'Compte',
    openMenu: 'Ouvrir le menu',
    close: 'Fermer',
    language: 'Langue',
    workspaceTitle: 'Espace de sourcing',
    shortcutSavedTitle: 'Fournisseurs enregistrés',
    shortcutSavedSub: 'Votre liste restreinte',
    shortcutSavedCount: '{n} enregistré(s)',
    shortcutTrackerTitle: 'Suivi d\'approche',
    shortcutTrackerSub: 'Gérez vos relances',
    shortcutTrackerCount: '{n} actif(s) dans le pipeline',
    shortcutTemplatesTitle: 'Modèles de message',
    shortcutTemplatesSub: 'Bibliothèque réutilisable',
    shortcutTemplatesCount: '{n} modèle(s)',
    shortcutSearchTitle: 'Nouvelle recherche',
    shortcutSearchSub: 'Analyser des fournisseurs',
    // Saved suppliers
    savedNav: 'Enregistrés',
    savedPageTitle: 'Fournisseurs enregistrés',
    savedPageSubtitle: 'Votre liste personnelle de fournisseurs prometteurs',
    saveSupplier: 'Enregistrer',
    savedSupplier: 'Enregistré',
    saving: 'En cours…',
    supplierSaved: 'Fournisseur enregistré',
    supplierUnsaved: 'Fournisseur retiré',
    noSavedSuppliers: 'Aucun fournisseur enregistré',
    noSavedSuppliersDesc: 'Enregistrez les fournisseurs prometteurs pour les retrouver plus tard',
    notes: 'Notes',
    notesPlaceholder: 'Vos notes personnelles…',
    addTag: 'Ajouter une étiquette',
    tag_best_price: 'Meilleur prix',
    tag_reliable: 'Fiable',
    tag_fast_shipping: 'Livraison rapide',
    tag_customization: 'Personnalisation',
    tag_test_later: 'À tester',
    tag_premium: 'Premium',
    tag_high_risk: 'Risqué',
    tag_negotiable_moq: 'MOQ négociable',
    tag_good_for_samples: 'Bon pour échantillons',
    saveChanges: 'Enregistrer les modifications',
    compareSelected: 'Comparer la sélection',
    selectToCompare: 'Sélectionner',
    savedAt: 'Enregistré le',
    forProduct: 'pour',
    // Outreach pipeline (Phase C)
    outreachStatus: 'Statut',
    pipelineLabel: 'Pipeline d\'approche',
    status_not_contacted: 'Non contacté',
    status_contacted: 'Contacté',
    status_replied: 'A répondu',
    status_quote_received: 'Devis reçu',
    status_sample_ordered: 'Échantillon commandé',
    status_negotiating: 'En négociation',
    status_closed: 'Clôturé',
    markAsContacted: 'Marquer comme contacté',
    markedContacted: 'Marqué comme contacté',
    statusUpdated: 'Statut mis à jour',
    allStatuses: 'Tous les statuts',
    setStatus: 'Définir le statut',
    statusChangedAt: 'Modifié le',
    // Why reasons
    why_best_price: 'Meilleur prix pour votre budget',
    why_fast_delivery: 'Livraison rapide',
    why_verified: 'Fournisseur vérifié',
    why_moq_fits: 'MOQ adapté à votre commande',
    why_low_risk: 'Fournisseur à faible risque',
    why_competitive: 'Prix compétitif',
    why_high_capacity: 'Fournisseur grande capacité'
  },
  en: {
    // Auth
    welcomeBack: 'Welcome back',
    login: 'Log in',
    loginSubtitle: 'Log in to find reliable suppliers',
    email: 'Email',
    password: 'Password',
    loggingIn: 'Logging in...',
    dontHaveAccount: "Don't have an account?",
    signUp: 'Sign up',
    createAccount: 'Create account',
    createAccountSubtitle: 'Start finding reliable suppliers today',
    fullName: 'Full Name',
    creatingAccount: 'Creating account...',
    alreadyHaveAccount: 'Already have an account?',
    register: 'Register',
    passwordStrength: 'Password strength',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    invalidEmail: 'Invalid email address',
    passwordMinLength: 'Password must be at least 6 characters',
    emailAlreadyUsed: 'Email already registered',
    
    // Header
    logout: 'Logout',
    
    // Dashboard
    dashboard: 'Dashboard',
    manageSearches: 'Manage your supplier searches',
    newSearch: 'New Search',
    noSearchesYet: 'No searches yet',
    noSearchesDesc: 'Start by creating your first supplier search',
    createNewSearch: 'Create New Search',
    quantity: 'Quantity',
    budget: 'Budget',
    suppliersFound: 'Suppliers Found',
    bestMatch: 'Best Match',
    units: 'units',
    
    // New Request
    newSupplierSearch: 'New Supplier Search',
    tellUsWhatYouNeed: 'Tell us what you\'re looking for',
    productName: 'Product Name',
    productNameRequired: 'Product Name *',
    productPlaceholder: 'e.g., Cotton T-shirts, Bluetooth Speakers',
    quantityUnits: 'Quantity (units)',
    quantityRequired: 'Quantity (units) *',
    budgetUSD: 'Budget (USD)',
    budgetRequired: 'Budget (USD) *',
    additionalNotes: 'Additional Notes (Optional)',
    notesPlaceholder: 'Any specific requirements, certifications, or preferences...',
    cancel: 'Cancel',
    findSuppliers: 'Find Suppliers',
    analyzingSuppliers: 'Analyzing suppliers...',
    failedToCreate: 'Failed to create request',
    
    // Results
    backToDashboard: 'Back to Dashboard',
    notes: 'Notes',
    bestMatchBadge: '\u2713 Best Match',
    verified: 'Verified',
    pricePerUnit: 'Price/Unit',
    moq: 'MOQ',
    leadTime: 'Lead Time',
    reliability: 'Reliability',
    days: 'days',
    lowRisk: 'Low Risk',
    mediumRisk: 'Medium Risk',
    highRisk: 'High Risk',
    risk: 'Risk',
    generateMessage: 'Generate Message',
    failedToGenerate: 'Failed to generate message. Please try again.',
    
    // Message Generator
    whatsappMessageFor: 'WhatsApp Message for',
    generatingMessage: 'Generating professional message...',
    copyToClipboard: 'Copy to Clipboard',
    copied: 'Copied!',
    messageLanguage: 'Message Language',
    english: 'English',
    french: 'French',
    
    // Loading & Session
    analyzingSuppliersLoading: 'Analyzing suppliers and verifying data...',
    requestNotFound: 'Request not found',
    sessionExpired: 'Your session has expired. Please log in again.',
    reconnect: 'Log in again',
    
    // Refresh & History
    refreshSearch: 'Refresh Search',
    refreshing: 'Refreshing...',
    lastUpdated: 'Last updated',
    viewPreviousResults: 'View previous results',
    viewCurrentResults: 'View current results',
    previousResults: 'Previous Results',
    currentResults: 'Current Results',
    
    // Decision support
    priceRange: 'Price Range',
    estBestPrice: 'Est. Best Price',
    topSupplier: 'Top Supplier',
    whyThisSupplier: 'Why this supplier',
    scoreExplanation: 'Score based on price, MOQ, delivery time, and supplier reliability',
    perUnit: '/unit',
    resultsSummary: 'Analysis Summary',
    // Score breakdown
    scoreBreakdown: 'Score breakdown',
    overallScore: 'Overall score',
    scorePrice: 'Price',
    scoreMoq: 'MOQ',
    scoreDelivery: 'Delivery',
    scoreReliability: 'Reliability',
    weight: 'Weight',
    viewDetails: 'View details',
    hideDetails: 'Hide details',
    scoreHelpTitle: 'How we calculate this score',
    scoreHelpIntro: 'Each supplier is scored out of 100 across 4 weighted criteria:',
    scoreHelpPrice: 'Price (40%) — compares unit price to your per-unit budget',
    scoreHelpMoq: 'MOQ (20%) — checks if the minimum order fits your quantity',
    scoreHelpDelivery: 'Delivery (20%) — shorter lead time scores higher',
    scoreHelpReliability: 'Reliability (20%) — based on supplier verification and track record',
    // Decision support v2
    recommendedBecause: 'Why this supplier:',
    scoreOutOf: 'Score',
    fastestSupplier: 'Fastest supplier',
    lowestMoqInsight: 'Lowest MOQ',
    bestPriceInsight: 'Best price',
    // Comparison
    addToComparison: 'Add to comparison',
    removeFromComparison: 'Remove from comparison',
    addedToComparison: 'Added',
    compareSuppliersBtn: 'Compare suppliers',
    selectedForCompare: 'selected to compare',
    maxComparisonReached: 'Maximum 3 suppliers',
    clearComparison: 'Clear',
    comparisonTitle: 'Supplier comparison',
    comparisonRowPrice: 'Price per unit',
    comparisonRowMoq: 'MOQ',
    comparisonRowDelivery: 'Delivery time',
    comparisonRowReliability: 'Reliability',
    comparisonRowTotal: 'Global score',
    comparisonRowRisk: 'Risk level',
    bestValue: 'Best',
    worstValue: 'Worst',
    winnerSummary: 'Our recommendation',
    winnerExplain: 'is the best choice because:',
    winsBestPrice: 'best price per unit',
    winsLowestMoq: 'lowest MOQ',
    winsFastestDelivery: 'fastest delivery',
    winsHighestReliability: 'highest reliability',
    winsHighestScore: 'highest global score',
    winsLowestRisk: 'lowest risk level',
    strengthsLabel: 'Strengths',
    weaknessesLabel: 'Weaknesses',
    bestBadge: 'Best',
    worstBadge: 'Worst',
    // PDF export
    exportPdf: 'Export PDF',
    exportingPdf: 'Generating PDF...',
    pdfReady: 'PDF report downloaded',
    pdfError: 'Failed to generate PDF',
    pdfEmptySaved: 'No suppliers to export',
    // Message generator v2
    messageType: 'Message type',
    msgTypeWhatsapp: 'WhatsApp',
    msgTypeEmail: 'Email',
    messageTone: 'Tone',
    toneePolite: 'Polite',
    toneDirect: 'Direct',
    toneNegotiation: 'Negotiation',
    toneePoliteHelp: 'Courteous and professional',
    toneDirectHelp: 'Short and to the point',
    toneNegotiationHelp: 'Pushes for better pricing',
    regenerate: 'Regenerate',
    editMessage: 'You can edit the message before copying',
    // Templates
    templatesNav: 'Templates',
    templatesPageTitle: 'Message templates',
    templatesPageSubtitle: 'Reuse your best messages to save time',
    newTemplate: 'New template',
    noTemplates: 'No templates yet',
    noTemplatesDesc: 'Save your messages to reuse them quickly',
    templateName: 'Template name',
    templateNamePlaceholder: 'e.g. Quick price inquiry',
    templateCategory: 'Category',
    templateBody: 'Message body',
    templateBodyHelp: 'Use {{supplier_name}}, {{product_name}}, {{quantity}}, {{budget}}, {{moq}}, {{lead_time}} as variables.',
    save: 'Save',
    saveAsTemplate: 'Save as template',
    useTemplate: 'Use a template',
    edit: 'Edit',
    duplicate: 'Duplicate',
    delete: 'Delete',
    confirmDelete: 'Delete this template?',
    templateSaved: 'Template saved',
    templateUpdated: 'Template updated',
    templateDeleted: 'Template deleted',
    templateDuplicated: 'Template duplicated',
    templateApplied: 'Template applied',
    templateError: 'Something went wrong',
    isDefault: 'Default',
    customLabel: 'Custom',
    usageCount: 'uses',
    pickATemplate: 'Pick a template',
    suggestTemplate: 'Suggest the best template for this context',
    allCategories: 'All categories',
    cat_price_inquiry: 'Price inquiry',
    cat_moq_negotiation: 'MOQ negotiation',
    cat_shipping_inquiry: 'Shipping',
    cat_sample_request: 'Samples',
    cat_branding: 'Branding',
    cat_general_intro: 'Introduction',
    backToResults: 'Back to results',
    // Mobile navigation + workspace (EN)
    navHome: 'Home',
    navSaved: 'Saved',
    navTracker: 'Tracker',
    navTemplates: 'Templates',
    navAccount: 'Account',
    openMenu: 'Open menu',
    close: 'Close',
    language: 'Language',
    workspaceTitle: 'Sourcing workspace',
    shortcutSavedTitle: 'Saved suppliers',
    shortcutSavedSub: 'Your shortlist',
    shortcutSavedCount: '{n} saved',
    shortcutTrackerTitle: 'Outreach tracker',
    shortcutTrackerSub: 'Manage follow-ups',
    shortcutTrackerCount: '{n} active in pipeline',
    shortcutTemplatesTitle: 'Message templates',
    shortcutTemplatesSub: 'Reusable library',
    shortcutTemplatesCount: '{n} templates',
    shortcutSearchTitle: 'New search',
    shortcutSearchSub: 'Analyse new suppliers',
    // Saved suppliers
    savedNav: 'Saved',
    savedPageTitle: 'Saved suppliers',
    savedPageSubtitle: 'Your personal shortlist of promising suppliers',
    saveSupplier: 'Save',
    savedSupplier: 'Saved',
    saving: 'Saving…',
    supplierSaved: 'Supplier saved',
    supplierUnsaved: 'Supplier removed',
    noSavedSuppliers: 'No saved suppliers yet',
    noSavedSuppliersDesc: 'Save promising suppliers to find them later',
    notes: 'Notes',
    notesPlaceholder: 'Your personal notes…',
    addTag: 'Add a tag',
    tag_best_price: 'Best price',
    tag_reliable: 'Reliable',
    tag_fast_shipping: 'Fast shipping',
    tag_customization: 'Customization',
    tag_test_later: 'Test later',
    tag_premium: 'Premium',
    tag_high_risk: 'High risk',
    tag_negotiable_moq: 'Negotiable MOQ',
    tag_good_for_samples: 'Good for samples',
    saveChanges: 'Save changes',
    compareSelected: 'Compare selected',
    selectToCompare: 'Select',
    savedAt: 'Saved on',
    forProduct: 'for',
    // Outreach pipeline (Phase C)
    outreachStatus: 'Status',
    pipelineLabel: 'Outreach pipeline',
    status_not_contacted: 'Not contacted',
    status_contacted: 'Contacted',
    status_replied: 'Replied',
    status_quote_received: 'Quote received',
    status_sample_ordered: 'Sample ordered',
    status_negotiating: 'Negotiating',
    status_closed: 'Closed',
    markAsContacted: 'Mark as contacted',
    markedContacted: 'Marked as contacted',
    statusUpdated: 'Status updated',
    allStatuses: 'All statuses',
    setStatus: 'Set status',
    statusChangedAt: 'Updated',
    // Why reasons
    why_best_price: 'Best price for your budget',
    why_fast_delivery: 'Fast delivery',
    why_verified: 'Verified supplier',
    why_moq_fits: 'MOQ fits your order',
    why_low_risk: 'Low risk supplier',
    why_competitive: 'Competitive pricing',
    why_high_capacity: 'High capacity supplier'
  }
};